<div class="blog-profile-holder">
  <div class="top-div">
    <div class="top-title" *ngIf="dataIsReady">{{ user.userName }}</div>
    <div
      *ngIf="!isMyProfile"
      class="profile-more-options"
      (click)="profileMoreOptions()"
    >
      <div class="dot" style="top: 12px"></div>
      <div class="dot" style="top: 18px"></div>
      <div class="dot" style="top: 24px"></div>
    </div>
    <div class="profile-back-holder" (click)="goback()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div
    class="page-holder"
    *ngIf="dataIsReady"
    id="scroll_area"
    #scrollTopProfile
    (scroll)="scroll(false, false)"
  >
    <div class="profile-img-holder">
      <img
        *ngIf="user.avatarPath !== ''"
        src="{{ user.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
      />
      <img *ngIf="user.avatarPath === ''" src="assets/blog/avatar.svg" />
    </div>
    <div class="followers-holder" (click)="followersFollowees(0)">
      <div class="followers-count">{{ followers }}</div>
      <div class="followers-title">دنبال‌کننده‌ها</div>
    </div>
    <div class="followings-holder" (click)="followersFollowees(1)">
      <div class="followings-count">{{ followees }}</div>
      <div class="followings-title">دنبال‌شده‌ها</div>
    </div>
    <div *ngIf="isMyProfile" class="profile-edit">
      <div class="profile-edit-button" (click)="setting()">ویرایش پروفایل</div>
    </div>
    <div class="name-holder" id="name{{ id }}">{{ user.name }}</div>
    <div class="bio" id="bio{{ id }}">{{ user.bio }}</div>
    <div
      *ngIf="
        !isMyProfile &&
        relationStatusSource === 'none' &&
        relationStatusTarget !== 'pending'
      "
      class="follow-user"
      (click)="follow()"
    >
      دنبال کردن
    </div>
    <div
      *ngIf="
        !isMyProfile &&
        relationStatusSource === 'ignore' &&
        relationStatusTarget !== 'pending'
      "
      class="follow-user"
      (click)="follow()"
    >
      دنبال کردن
    </div>
    <div
      *ngIf="
        !isMyProfile &&
        relationStatusSource === 'pending' &&
        relationStatusTarget !== 'pending'
      "
      class="follow-pending"
      (click)="unFollow()"
    >
      در انتظار تایید
    </div>
    <div
      *ngIf="
        !isMyProfile &&
        relationStatusSource === 'accept' &&
        relationStatusTarget !== 'pending'
      "
      class="following-user"
      (click)="unFollow()"
    >
      دنبال شده
    </div>
    <div
      *ngIf="!isMyProfile && relationStatusSource === 'block'"
      class="follow-user"
      (click)="unBlockOption()"
    >
      آنبلاک
    </div>

    <div
      *ngIf="
        !isMyProfile &&
        relationStatusSource !== 'block' &&
        relationStatusTarget === 'pending'
      "
      class="accept-user"
      (click)="acceptFollowing()"
    >
      قبول درخواست
    </div>
    <div
      *ngIf="
        !isMyProfile &&
        relationStatusSource !== 'block' &&
        relationStatusTarget === 'pending'
      "
      class="reject-user"
      (click)="rejectFollowing()"
    >
      رد درخواست
    </div>

    <div *ngIf="postsCount >= 0" class="posts-title">
      پست‌ها ({{ postsCount }})
    </div>
    <div *ngIf="postsCount < 0" class="posts-title">پست‌ها</div>
    <div class="seperator"></div>
    <ul style="margin: 0; padding: 0; top: 64px; position: relative">
      <li
        *ngFor="let post of userPosts; let i = index; let last = last"
        [ngStyle]="{ 'margin-top': i === 0 ? '16px' : '0px' }"
      >
        <app-post
          [id]="id"
          [post]="post"
          [username]="myUsername"
          [loadImage]="loadImage[i]"
          class="appPostProfile"
        ></app-post>
      </li>
    </ul>
    <div *ngIf="!isMyProfile && postsCount === 0" class="no-post">
      پستی منتشر نشده است
    </div>
    <div *ngIf="isMyProfile && postsCount === 0" class="no-post">
      پست به اشتراک بگذارید
    </div>
    <div *ngIf="isMyProfile && postsCount === 0" class="no-post-description">
      پست‌های شما در صفحه تریبون شما نمایش داده می‌شود
    </div>
    <div
      *ngIf="isMyProfile && postsCount === 0"
      class="no-post-create"
      (click)="createPost()"
    >
      اولین پست خود را به اشتراک بگذارید
    </div>
    <img
      *ngIf="
        !isMyProfile &&
        user.status === 'private' &&
        relationStatusSource !== 'accept'
      "
      class="private-img"
      src="assets/blog/lock-gray.svg"
    />
    <div
      *ngIf="
        !isMyProfile &&
        user.status === 'private' &&
        relationStatusSource !== 'accept'
      "
      class="private-title"
    >
      صفحه خصوصی میباشد
    </div>
    <div
      class="user-more-posts"
      *ngIf="postsCount > (postsPage + 1) * postPerPage"
    >
      <div class="user-more-posts-title" (click)="showMorePosts()">
        پست‌های بیشتر
      </div>
    </div>
  </div>

  <!-- <div class="setting-page" id="settingPage" *ngIf="showSetting">
    <app-blog-setting
      [id]="settingId"
      style="width: 100%; height: 100%"
    ></app-blog-setting>
    <div class="blog-with-tag-back-holder" (click)="closeSetting()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div> -->
  <div class="botomsheet" attr.id="botomsheet{{ id }}" *ngIf="showDetail">
    <app-post-detail
      [id]="detailId"
      [post]="selectedPost"
      style="width: 100%; height: 100%"
    ></app-post-detail>
    <div class="close" (click)="closeDetail()">بستن</div>
  </div>

  <div
    class="creat-post-page"
    id="createPostPage{{ id }}"
    *ngIf="showCreatePost"
  >
    <app-blog-creat-post
      [user]="user"
      style="width: 100%; height: 100%"
    ></app-blog-creat-post>
    <div class="blog-create-post-back-holder" (click)="closeCreatePostButton()">
      لغو
    </div>
  </div>
</div>
